// @flow

import React, { type Node } from 'react';
import { getOxxoBarcode, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import Barcode from 'react-barcode';
import styled from 'styled-components';

export function OxxoBarcode(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <>
      <Message>Dictale estos números para el cajero OXXO para realizar tu pago:</Message>
      <BarcodeWrapper>
        <Barcode
          format="CODE128"
          value={getOxxoBarcode(incomingPayment)}
          displayValue={false}
          textMargin={0}
          height={50}
        />
      </BarcodeWrapper>
    </>
  );
}

const BarcodeWrapper = styled.div`
  svg {
    width: 100%;
  }
`;

const Message = styled.p`
  color: rgb(115, 128, 147);
  font-size: 1.5em;
  text-align: center;
`;
